module.exports = __webpack_public_path__ + "img/MetaMask_Fox.50f87869.png";